import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit, ElementRef } from '@angular/core';
import {
    BaseFilterDefinition,
    DashboardDefinitionDTO,
    DashboardFilterFormInd,
    keyValueDto,
    organisationDataSetChange,
    organisationDataSetsDTO,
} from 'src/app/core/services/dashboardsv2.service';

@Component({
    selector: 'app-filter-container',
    templateUrl: './filter-container.component.html',
    styleUrls: ['./filter-container.component.scss'],
})
export class FilterContainerComponent implements OnInit, AfterViewInit {
    selectedOrganisation: organisationDataSetsDTO;
    selectedOrganisationDataSet: keyValueDto;

    @Input() config: DashboardDefinitionDTO;
    @Output() filtersChanged = new EventEmitter();
    @Output() orgDataSetChanged = new EventEmitter<organisationDataSetChange>();

    get DashboardFilterFormInd(): typeof DashboardFilterFormInd {
        return DashboardFilterFormInd;
    }

    constructor(private el: ElementRef) {}

    ngOnInit(): void {
        this.selectedOrganisation = this.config.organisationDataSets[0];
        this.selectedOrganisationDataSet = this.selectedOrganisation.dataSets[0];

        // set default first value and load data for Indicator filter
        let singleFilterSelect = this.config.filters.filter((m) => m.allowMultiSelect == false && m.selection.length !== 1);
        singleFilterSelect.forEach((a) => this.onSingleSelection(a, a.options[0].id));
    }

    ngAfterViewInit(): void {
        const wrapperEl = this.el.nativeElement.querySelector('.filters-wrapper');
        const sentinelEl = this.el.nativeElement.querySelector('.sentinel');

        if (!wrapperEl || !sentinelEl) {
            return;
        }

        const observer = new IntersectionObserver(
            ([e]) => {
                wrapperEl.classList.toggle('is-scrolled', !e.isIntersecting);
            },
            { threshold: [0] }
        );

        observer.observe(sentinelEl);
    }

    /** Event fired when a filter has been updated */
    onFilterChanged(filter: BaseFilterDefinition, selection: number[]) {
        if (JSON.stringify(selection) !== JSON.stringify(filter.selection)) {
            filter.selection = selection;
            this.createAndEmitDataSetRequest();
        }
    }

    /** Create and emit the current indicator filter state to the dashboard */
    onSingleSelection(filter: BaseFilterDefinition, emitVal: any) {
        let selection: Array<number>;
        selection = [emitVal];

        if (JSON.stringify(selection) !== JSON.stringify(filter.selection)) {
            filter.selection = selection;
            this.createAndEmitDataSetRequest();
        }
    }

    /** Create and emit the current filter state to the dashboard */
    createAndEmitDataSetRequest() {
        this.filtersChanged.emit();
    }

    createOrganisationChangeRequest() {
        this.orgDataSetChanged.emit({
            organisationId: this.selectedOrganisation.id,
            dataSetId: this.selectedOrganisation.dataSets[0].id,
        });
        this.selectedOrganisationDataSet = this.selectedOrganisation.dataSets[0];
    }

    createOrganisationDataSetChangeRequest() {
        this.orgDataSetChanged.emit({
            organisationId: this.selectedOrganisation.id,
            dataSetId: this.selectedOrganisationDataSet.id,
        });
    }
}
